<template>
  <div>
    <header class="fixed-header">
      <img src="https://assets.codepen.io/11151897/Riskypawslogo.png" alt="Your Logo" class="logo">
      <div class="button-container">
        <button @click="showModal = true" class="header-button">Join the WaitList</button>
      </div>
    </header>
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span @click="showModal = false" class="close-button">&times;</span>
        <h2>Join the WaitList</h2>
        <input v-model="username" placeholder="Username" type="text" />
        <input v-model="password" placeholder="Password" type="password" />
        <input v-model="name" placeholder="Full Name" type="text" />
        <input v-model="email" placeholder="Email" type="email" />
        <input v-model="formattedPhoneNumber" placeholder="Phone Number" type="tel" />
        <button @click="authenticate">Submit</button>
      </div>
    </div>
    <div class="content">
   
    




      






  </div>
  </div>

</template>
<script>
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      showModal: false,
      isLogin: true,
      username: '',
      password: '',
      name: '', // Full name for sign-up
      phoneNumber: '', // Phone number for sign-up, initially empty
      email: '', // Email for sign-up
      verificationStep: false,
      verificationCode: '',
      error: '',
      verificationMessage: '',
    };
  },
  computed: {
    formattedPhoneNumber: {
      get() {
        // Format the phone number as needed
        if (!this.phoneNumber.startsWith('+')) {
          return `+1${this.phoneNumber}`;
        }
        return this.phoneNumber;
      },
      set(value) {
        // Only keep the numeric characters and the '+' symbol
        const numericValue = value.replace(/[^\d+]/g, '');
        this.phoneNumber = numericValue;
      }
    }
  },
  methods: {
    async authenticate() {
      try {
        if (this.isLogin) {
          // Login logic
          const user = await Auth.signIn(this.username, this.password);
          console.log('Logged in:', user);
          // Redirect logic after login
        } else {
          // Sign-up logic
          const user = await Auth.signUp({
            username: this.username,
            password: this.password,
            attributes: {
              email: this.email,
              name: this.name,
              phone_number: this.formattedPhoneNumber,
            },
          });
          console.log('Signed up:', user);
          this.verificationStep = true;
        }
      } catch (error) {
        console.error(error);
        this.error = error.message || "An unexpected error occurred";
      }
    },
    // ... Other methods ...
  }
};
</script>
<style scoped>
/* Header styles */
.fixed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 10px 20px;
}

.button-container {
  display: flex;
}

.header-button {
  display: inline-block;
  padding: 6px 14px;
  margin: 0 5px;
  border-radius: 20px;  /* More rounded */
  background-color: #43284F;
  color: #fff;
  text-decoration: none;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);  /* Add shadow */
}

.header-button:hover {
  background-color: #b5a5bc;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.24);  /* Enhanced shadow on hover */
  transform: translateY(-2px);  /* Slight lift */
}

/* Logo styles */
.logo {
  display: block;
  max-width: 150px;
  height: auto;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content {
  background-color: #6C5B7B;
  padding: 20px;
  border-radius: 15px;
  width: 300px;
  text-align: center;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
}
@media only screen and (max-width: 768px) {
    .fixed-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .button-container {
      justify-content: flex-start;
      width: 100%;
    }

    .header-button {
      margin: 5px 0;
      width: 100%;
    }

    .logo {
      max-width: 100px;
    }

    .modal-content {
      width: 90%;
    }
  }

  .auth-container {
    width: 350px;
    margin: auto;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0,0,0,0.1);
    background-color: #C9B6D9 ;
    text-align: center;
}

.auth-input {
    width: calc(100% - 20px);
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
}

.auth-button, .toggle-button, .google-button {
    width: calc(100% - 20px);
    padding: 12px;
    border: none;
    border-radius: 5px;
    margin-bottom: 20px;
    cursor: pointer;
    font-size: 16px;
}

.auth-button {
    background-color: #4A148C;
    color: white;
}

.toggle-button {
    background-color: #e0e0e0;
}

.google-button {
    background-color: #dd4b39;
    color: white;
}

.error-message {
    color: red;
    margin-bottom: 20px;
}

.logo {
    width: 300px; 
    margin: 5px auto 10px;
    display: block;
}

.success-message {
    color: green;
    margin-bottom: 20px;
}

.amazon-button {
  background-color: #4A148C;
  color: white;
}
</style>